export default __webpack_public_path__ + "static/media/incoming-warning.04df5ccd.svg";